<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/arlrex/tc-custom/9781439658529.jpg?1704586019539" alt="This image is the cover for the book Lost Tea Rooms of Downtown Cincinnati, American Palate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lost Tea Rooms of Downtown Cincinnati, American Palate
      </h1>
      <p class="bookDescription body article font2">
        <p><b>It was a different time. Ladies wore gloves, hats and nice attire to luncheons at the Woman's Exchange.</b></p><br/><p>Shillito's provided a cosmopolitan environment for its patrons, while Mullane's was the perfect place to sip and socialize. The popular Good Morning Show radio program hosted by charming Bob Braun, and later Nick Clooney, was broadcast from McAlpin's Tea Room. Women gathered at Pogue's and Mabley &amp; Carew tea rooms to celebrate birthdays, as well as wedding and baby showers, over dainty tea sandwiches. Author Cynthia Kuhn Beischel brings the Queen City's bygone downtown tea rooms back to life and shares more than one hundred beloved recipes.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cynthia Kuhn Beischel
      </h2>
      
      <p class="authorDescription body article">Cincinnati native Cynthia Kuhn Beischel is the co-author or author of three books: Virginia Bakery Remembered, From Eulogy to Joy and Discover the Past. Cynthia is a co-founder and committee member of the Glendale Community Library, a board member of Glendale's Harry Whiting Brown Community Center and a member of the Glendale Heritage Preservation Association.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c8de1ffa